module.exports = __webpack_public_path__ + "img/card2.d58fc387.jpg";